<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách phòng ban</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active">Phòng ban</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_modal">
              <i class="fa fa-plus"></i> Thêm phòng ban
            </a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Mã</th>
                <th>Tên phòng ban</th>
                <th>Giờ sáng (bđ → kt)</th>
                <th>Giờ chiều (bđ → kt)</th>
                <th>Kiểu chấm công</th>
                <th>Trạng thái</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pb in phongBans" :key="pb.idPhongBan">
                <td>{{ pb.maPhongBan }}</td>
                <td>{{ pb.tenPhongBan }}</td>
                <td>
                  <span>{{ showTime(pb.gioBatDauSang) }} → {{ showTime(pb.gioKetThucSang) }}</span>
                </td>
                <td>
                  <span>{{ showTime(pb.gioBatDauChieu) }} → {{ showTime(pb.gioKetThucChieu) }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="pb.kieuChamCong === 'NGAY_2x' ? 'badge-info' : 'badge-primary'"
                  >
                    {{ labelKieuChamCong(pb.kieuChamCong) }}
                  </span>
                </td>
                <td>
                  <span
                    :class="['badge', pb.trangThai === 1 ? 'badge-success' : 'badge-secondary']"
                  >
                    {{ pb.trangThai === 1 ? 'Hoạt động' : 'Ngưng' }}
                  </span>
                </td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown">
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#edit_modal"
                        @click="editPhongBan(pb)"
                      >
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#delete_modal"
                        @click="confirmDelete(pb.idPhongBan)"
                      >
                        <i class="fa fa-trash-o m-r-5"></i> Xóa (mềm)
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="phongBans.length === 0 && !loading">
                <td colspan="7" class="text-center">Không có phòng ban nào.</td>
              </tr>
              <tr v-if="loading">
                <td colspan="7" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-3" v-if="totalElements > 0">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info">
            Hiển thị
            {{ Math.min(currentPage * pageSize + 1, totalElements) }}
            đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }}
            của {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <ul class="pagination">
            <li
              class="paginate_button page-item previous"
              :class="{ disabled: currentPage === 0 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(currentPage - 1)"
              >
                Previous
              </a>
            </li>
            <li
              v-for="pageNum in totalPages"
              :key="pageNum"
              class="paginate_button page-item"
              :class="{ active: pageNum === currentPage + 1 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(pageNum - 1)"
              >
                {{ pageNum }}
              </a>
            </li>
            <li
              class="paginate_button page-item next"
              :class="{ disabled: currentPage === totalPages - 1 }"
            >
              <a
                href="#"
                class="page-link"
                @click.prevent="goToPage(currentPage + 1)"
              >
                Next
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addPhongBan">
            <div class="modal-header">
              <h5 class="modal-title">Thêm phòng ban</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã phòng ban<span class="text-danger">*</span></label>
                <input v-model.trim="newPhongBan.maPhongBan" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Tên phòng ban<span class="text-danger">*</span></label>
                <input v-model.trim="newPhongBan.tenPhongBan" class="form-control" required />
              </div>

              <div class="form-group">
                <label>Kiểu chấm công</label>
                <select v-model="newPhongBan.kieuChamCong" class="form-control">
                  <option
                    v-for="opt in kieuChamCongOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ bắt đầu sáng</label>
                    <input
                      type="time"
                      v-model="newPhongBan.gioBatDauSang"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ kết thúc sáng</label>
                    <input
                      type="time"
                      v-model="newPhongBan.gioKetThucSang"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ bắt đầu chiều</label>
                    <input
                      type="time"
                      v-model="newPhongBan.gioBatDauChieu"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ kết thúc chiều</label>
                    <input
                      type="time"
                      v-model="newPhongBan.gioKetThucChieu"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Thêm</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updatePhongBan">
            <div class="modal-header">
              <h5 class="modal-title">Sửa phòng ban</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã phòng ban<span class="text-danger">*</span></label>
                <input v-model.trim="currentPhongBan.maPhongBan" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Tên phòng ban<span class="text-danger">*</span></label>
                <input v-model.trim="currentPhongBan.tenPhongBan" class="form-control" required />
              </div>

              <div class="form-group">
                <label>Kiểu chấm công</label>
                <select v-model="currentPhongBan.kieuChamCong" class="form-control">
                  <option
                    v-for="opt in kieuChamCongOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ bắt đầu sáng</label>
                    <input
                      type="time"
                      v-model="currentPhongBan.gioBatDauSang"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ kết thúc sáng</label>
                    <input
                      type="time"
                      v-model="currentPhongBan.gioKetThucSang"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ bắt đầu chiều</label>
                    <input
                      type="time"
                      v-model="currentPhongBan.gioBatDauChieu"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Giờ kết thúc chiều</label>
                    <input
                      type="time"
                      v-model="currentPhongBan.gioKetThucChieu"
                      class="form-control"
                      placeholder="HH:mm"
                    >
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div id="delete_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h3>Bạn có chắc muốn xóa phòng ban này?</h3>
            <div class="mt-3">
              <button class="btn btn-danger mr-2" @click="deletePhongBan">Xóa</button>
              <button class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import api from '@/api/index.js';
import { useToast } from 'vue-toastification';

const toast = useToast();

const phongBans = ref([]);
const loading = ref(true);

// Enum options khớp BE: BUOI_2x2 | NGAY_2x
const kieuChamCongOptions = [
  { value: 'BUOI_2x2', label: '4 lần' },
  { value: 'NGAY_2x', label: '2 lần' }
];

// DTO thêm mới
const newPhongBan = reactive({
  maPhongBan: '',
  tenPhongBan: '',
  kieuChamCong: 'BUOI_2x2',
  gioBatDauSang: null,
  gioKetThucSang: null,
  gioBatDauChieu: null,
  gioKetThucChieu: null
});

// DTO chỉnh sửa
const currentPhongBan = reactive({
  idPhongBan: null,
  maPhongBan: '',
  tenPhongBan: '',
  trangThai: 1,
  kieuChamCong: 'BUOI_2x2',
  gioBatDauSang: null,
  gioKetThucSang: null,
  gioBatDauChieu: null,
  gioKetThucChieu: null
});

const phongBanToDeleteId = ref(null);

const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const showTime = (t) => {
  if (!t) return '--:--';
  const s = String(t);
  // nếu BE trả 'HH:mm:ss' thì cắt bớt
  if (s.length === 8 && s[2] === ':' && s[5] === ':') {
    return s.substring(0, 5);
  }
  return s;
};

const labelKieuChamCong = (val) => {
  if (val === 'NGAY_2x') return '2 lần';
  if (val === 'BUOI_2x2') return '4 lần';
  return 'Chưa cấu hình';
};

const fetchPhongBans = async () => {
  loading.value = true;
  try {
    const res = await api.get('/api/phong-ban', {
      params: { page: currentPage.value, size: pageSize.value }
    });
    const pageData = res.data?.data || {};
    phongBans.value = pageData.content || [];
    totalElements.value = pageData.totalElements || 0;
    totalPages.value = pageData.totalPages || 0;
  } catch (e) {
    console.error(e);
    toast.error('Không thể tải danh sách phòng ban');
  } finally {
    loading.value = false;
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchPhongBans();
  }
};

// '' -> null cho time
const norm = (val) => (val && String(val).trim() !== '' ? val : null);

const addPhongBan = async () => {
  try {
    const payload = {
      maPhongBan: newPhongBan.maPhongBan?.trim(),
      tenPhongBan: newPhongBan.tenPhongBan?.trim(),
      kieuChamCong: newPhongBan.kieuChamCong,
      gioBatDauSang: norm(newPhongBan.gioBatDauSang),
      gioKetThucSang: norm(newPhongBan.gioKetThucSang),
      gioBatDauChieu: norm(newPhongBan.gioBatDauChieu),
      gioKetThucChieu: norm(newPhongBan.gioKetThucChieu)
    };
    const res = await api.post('/api/phong-ban', payload);
    toast.success(res.data.message || 'Thêm thành công');

    newPhongBan.maPhongBan = '';
    newPhongBan.tenPhongBan = '';
    newPhongBan.kieuChamCong = 'BUOI_2x2';
    newPhongBan.gioBatDauSang = null;
    newPhongBan.gioKetThucSang = null;
    newPhongBan.gioBatDauChieu = null;
    newPhongBan.gioKetThucChieu = null;

    $('#add_modal').modal('hide');
    fetchPhongBans();
  } catch (e) {
    console.error(e);
    toast.error('Lỗi khi thêm phòng ban');
  }
};

const editPhongBan = (pb) => {
  Object.assign(currentPhongBan, {
    idPhongBan: pb.idPhongBan,
    maPhongBan: pb.maPhongBan,
    tenPhongBan: pb.tenPhongBan,
    trangThai: pb.trangThai ?? 1,
    kieuChamCong: pb.kieuChamCong || 'BUOI_2x2',
    gioBatDauSang: pb.gioBatDauSang || null,
    gioKetThucSang: pb.gioKetThucSang || null,
    gioBatDauChieu: pb.gioBatDauChieu || null,
    gioKetThucChieu: pb.gioKetThucChieu || null
  });
};

const updatePhongBan = async () => {
  try {
    const payload = {
      maPhongBan: currentPhongBan.maPhongBan?.trim(),
      tenPhongBan: currentPhongBan.tenPhongBan?.trim(),
      kieuChamCong: currentPhongBan.kieuChamCong,
      gioBatDauSang: norm(currentPhongBan.gioBatDauSang),
      gioKetThucSang: norm(currentPhongBan.gioKetThucSang),
      gioBatDauChieu: norm(currentPhongBan.gioBatDauChieu),
      gioKetThucChieu: norm(currentPhongBan.gioKetThucChieu)
    };
    const res = await api.put(
      `/api/phong-ban/${currentPhongBan.idPhongBan}`,
      payload
    );
    toast.success(res.data.message || 'Cập nhật thành công');
    $('#edit_modal').modal('hide');
    fetchPhongBans();
  } catch (e) {
    console.error(e);
    toast.error('Lỗi khi cập nhật');
  }
};

const confirmDelete = (id) => {
  phongBanToDeleteId.value = id;
};

const deletePhongBan = async () => {
  try {
    const res = await api.delete(`/api/phong-ban/${phongBanToDeleteId.value}`);
    toast.success(res.data.message || 'Xóa thành công');
    $('#delete_modal').modal('hide');
    fetchPhongBans();
  } catch (e) {
    console.error(e);
    toast.error('Lỗi khi xóa');
  }
};

onMounted(fetchPhongBans);
</script>
